var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B5C1DB",
    d: "M34.115 3.332H5.882a2.416 2.416 0 0 0-2.45 2.383v28.567a2.417 2.417 0 0 0 2.45 2.383h28.233a2.417 2.417 0 0 0 2.45-2.383V5.715a2.417 2.417 0 0 0-2.45-2.383m-20.633 27.9h-5v-15h5zm-2.5-17.1a2.6 2.6 0 0 1 0-5.2 2.617 2.617 0 1 1 0 5.2m20.533 17.1h-5v-8.05c0-2.017-.716-3.334-2.533-3.334a2.75 2.75 0 0 0-2.567 1.817c-.13.392-.187.804-.166 1.217v8.333h-5v-15h5v2.117a5 5 0 0 1 4.516-2.5c3.334 0 5.75 2.15 5.75 6.766z"
  })));
};
export default SvgLinkedin;